import React from "react";
import MetaTags from "react-meta-tags";

const WebsiteBuilder = () => {
  return (
    <div>
      <MetaTags>
        <title>Set Title</title>
        <meta
          name="description"
          content="Idatahost is the best web hosting provider"
        />
      </MetaTags>
      <div className="main">
        {/*hero section start*/}
        <section className="ptb-120 gradient-bg">
          <div className="container">
            <div className="row align-items-center justify-content-between">
              <div className="col-md-7 col-lg-6">
                <div className="hero-content-wrap text-white">
                  <h1 className="text-white">
                    Windows Reseller Hosting Up to 50% OFF
                  </h1>
                  <p className="lead">
                    Web hosting made easy & affordable, hosting services
                    solution for successful personal and business websites.
                  </p>
                  <a href="#" className="btn btn-brand-03 btn-lg">
                    Get Start Now
                  </a>
                </div>
              </div>
              <div className="col-md-4 col-lg-5">
                <div className="big-price-wrap position-relative">
                  <div className="price-block d-flex justify-content-center text-white">
                    <span className="price-currency">$</span>
                    <div className="offer-price">15</div>
                    <div className="right-block d-flex">
                      <span className="cent-value">.99</span>
                      <span className="per-value">/mo</span>
                    </div>
                  </div>
                  <span className="d-block text-white regular-price text-center">
                    Regular Price <strong>$10.99</strong> *
                  </span>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/*hero section end*/}

        {/*pricing section start*/}
        <section id="pricing" className="pricing-section ptb-100">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-md-9 col-lg-8">
                <div className="section-heading text-center mb-4">
                  <h2>Choose Your Business Plan</h2>
                  <p className="lead">
                    Professional hosting at an affordable price. Distinctively
                    recaptiualize principle-centered core competencies through
                    client-centered core competencies.
                  </p>
                </div>
              </div>
            </div>
            <div className="row align-items-center justify-content-md-center justify-content-center">
              <div className="col-lg-3 col-md-6 col-sm-6">
                <div className="bg-white single-pricing-pack mt-4 border">
                  <div className="text-center pricing-header py-4">
                    <h6 className="mb-2 text-uppercase">Tier 1</h6>
                    <div className="price mb-0 monthly-price color-secondary">
                      <span>$</span>19.99
                    </div>
                    <span className="p-month"> Per Month</span>
                  </div>
                  <div className="pricing-content text-center">
                    <ul className="list-unstyled mb-4 pricing-feature-list">
                      <li>
                        <span>2 GB</span> RAM
                      </li>
                      <li>
                        <span>50 GB</span> Storage
                      </li>
                      <li>
                        <span>4 TB</span> Bandwidth
                      </li>
                      <li>
                        <span>24/7</span> Support
                      </li>
                      <li>
                        <span>4</span> Cores
                      </li>
                    </ul>
                    <div className="text-center">
                      <a
                        href="#"
                        className="btn btn-brand-01 mb-2"
                        target="_blank">
                        Purchase now
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-3 col-md-6 col-sm-6">
                <div className="popular-price bg-white single-pricing-pack mt-4 border">
                  <div className="text-center pricing-header py-4 text-white">
                    <h6 className="mb-2 h5 text-white text-uppercase">
                      Tier 2
                    </h6>
                    <div className="price mb-0 monthly-price">
                      <span>$</span>45.99
                    </div>
                    <span className="p-month"> Per Month</span>
                  </div>
                  <div className="pricing-content text-center">
                    <ul className="list-unstyled mb-4 pricing-feature-list">
                      <li>
                        <span>4 GB</span> RAM
                      </li>
                      <li>
                        <span>100 GB</span> Storage
                      </li>
                      <li>
                        <span>5 TB</span> Bandwidth
                      </li>
                      <li>
                        <span>24/7</span> Support
                      </li>
                      <li>
                        <span>4</span> Cores
                      </li>
                    </ul>
                    <div className="text-center">
                      <a
                        href="#"
                        className="btn btn-brand-03 mb-2"
                        target="_blank">
                        Purchase now
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-3 col-md-6 col-sm-6">
                <div className="bg-white single-pricing-pack mt-4 border">
                  <div className="text-center pricing-header py-4">
                    <h6 className="mb-2 text-uppercase">Tier 3</h6>
                    <div className="price mb-0 monthly-price color-secondary">
                      <span>$</span>66.99
                    </div>
                    <span className="p-month"> Per Month</span>
                  </div>
                  <div className="pricing-content text-center">
                    <ul className="list-unstyled mb-4 pricing-feature-list">
                      <li>
                        <span>8 GB</span> RAM
                      </li>
                      <li>
                        <span>200 GB</span> Storage
                      </li>
                      <li>
                        <span>6 TB</span> Bandwidth
                      </li>
                      <li>
                        <span>24/7</span> Support
                      </li>
                      <li>
                        <span>4</span> Cores
                      </li>
                    </ul>
                    <div className="text-center">
                      <a
                        href="#"
                        className="btn btn-brand-01 mb-2"
                        target="_blank">
                        Purchase now
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-3 col-md-6 col-sm-6">
                <div className="bg-white single-pricing-pack mt-4 border">
                  <div className="text-center pricing-header py-4">
                    <h6 className="mb-2 text-uppercase">Tier 4</h6>
                    <div className="price mb-0 monthly-price color-secondary">
                      <span>$</span>99.99
                    </div>
                    <span className="p-month"> Per Month</span>
                  </div>
                  <div className="pricing-content text-center">
                    <ul className="list-unstyled mb-4 pricing-feature-list">
                      <li>
                        <span>16 GB</span> RAM
                      </li>
                      <li>
                        <span>400 GB</span> Storage
                      </li>
                      <li>
                        <span>7 TB</span> Bandwidth
                      </li>
                      <li>
                        <span>24/7</span> Support
                      </li>
                      <li>
                        <span>4</span> Cores
                      </li>
                    </ul>
                    <div className="text-center">
                      <a
                        href="#"
                        className="btn btn-brand-01 mb-2"
                        target="_blank">
                        Purchase now
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-12">
                <div className="support-cta text-center mt-5">
                  <h5 className="mb-1">
                    <span className="ti-headphone-alt color-primary mr-3"></span>
                    We're Here to Help You
                  </h5>
                  <p>
                    Have some questions? <a href="#">Chat with us now</a>, or
                    <a href="#">send us an email</a> to get in touch.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/*pricing section end*/}

        {/*feature section start*/}
        <section
          id="features"
          className="feature-tab-section ptb-100 gray-light-bg">
          <div className="container">
            <div className="row">
              <div className="col-xl-5 col-lg-5 col-12 order-lg-last align-self-center">
                <div className="image-box fadein text-xl-right text-center">
                  <img
                    src="assets/img/email-feature-img.jpg"
                    alt="wp-hosting"
                    className="img-fluid"
                  />
                </div>
              </div>
              <div className="col-xl-7 col-lg-7 col-12 order-xl-first">
                <h2>Advanced Search to Make your Life Fester and Easier</h2>
                <p>
                  Progressively matrix mission-critical core competencies
                  without magnetic paradigms. Appropriately develop flexible ROI
                  without goal-oriented customer service. Seamlessly.
                </p>
                <div className="row pt-2">
                  <div className="col-md-6 col-12">
                    <h5>WordPress Optimization</h5>
                    <ul className="disc-style">
                      <li>Latest and Fastest PHP/MySQL version</li>
                      <li>SSD-only cloud with guaranteed CPU</li>
                      <li>HTTP/2 and free CloudFlare CDN</li>
                      <li>Observer Resource Monitoring</li>
                    </ul>
                  </div>
                  <div className="col-md-6 col-12">
                    <h5>Extra RocketBooster</h5>
                    <ul className="disc-style">
                      <li>Varnish Static and Dynamic caching</li>
                      <li>LiteSpeed LSPHP Technology</li>
                      <li>Opcode Caching</li>
                      <li>Optimized static content processing</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div className="row justify-content-between mt-5">
              <div className="col-xl-5 col-lg-5 col-12 order-lg-last align-self-center">
                <div className="image-box fadein text-xl-right text-center">
                  <img
                    src="assets/img/macbook.png"
                    alt="wp-hosting"
                    className="img-fluid"
                  />
                </div>
              </div>
              <div className="col-xl-7 col-lg-7 col-12 order-xl-last">
                <h2>Everything You Need at Your Fingertips</h2>
                <p>
                  Efficiently reintermediate long-term high-impact channels
                  without equity invested technology. Quickly brand backend
                  web-readiness without cross-platform e-services.
                </p>
                <div className="row pt-2">
                  <div className="col-md-6 col-12">
                    <h5>Exclusive Features</h5>
                    <ul className="disc-style">
                      <li>Daily Backups & free backup restore</li>
                      <li>Security Updates and Patching</li>
                      <li>Performance and resource monitoring</li>
                      <li>Step-by-step Tutorials & Knowledgebase</li>
                    </ul>
                  </div>
                  <div className="col-md-6 col-12">
                    <h5>WordPress Services</h5>
                    <ul className="disc-style">
                      <li>1-click WordPress Installation</li>
                      <li>Free WordPress Transfer</li>
                      <li>Themes and plugins installation</li>
                      <li>Malware Scan & Reports</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/*feature section end*/}

        {/*call to action new section start*/}
        <section className="ptb-60 primary-bg">
          <div className="container">
            <div className="row align-items-center justify-content-between">
              <div className="col-12 col-lg-6">
                <div className="cta-content-wrap text-white">
                  <h2 className="text-white">
                    24/7 Expert Hosting Support Our Customers Love
                  </h2>
                  <p>
                    Objectively innovate high compellingly maintain
                    progressively pursue mission-critical information quality
                    imperatives.
                  </p>
                </div>
                <div className="support-action d-inline-flex flex-wrap">
                  <a href="mailto:support@yourdomain.com" className="mr-3">
                    <i className="fas fa-comment mr-1 color-accent"></i>
                    <span>support@idatahost.com</span>
                  </a>
                  <a href="tel:+00123456789" className="mb-0">
                    <i className="fas fa-phone-alt mr-1 color-accent"></i>
                    <span>+880 1400 88 34 00</span>
                  </a>
                </div>
              </div>
              <div className="col-md-6 col-lg-4 d-none d-lg-block">
                <div className="cta-img-wrap text-center">
                  <img
                    src="assets/img/call-center-support.svg"
                    width="250"
                    className="img-fluid"
                    alt="server room"
                  />
                </div>
              </div>
            </div>
          </div>
        </section>
        {/*call to action new section end*/}

        {/*testimonial and review section start*/}
        <section className="review-section ptb-100 gray-light-bg">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-md-6 col-lg-4">
                <div className="section-heading">
                  <h2>Trusted By Clients And Industry Experts</h2>
                  <p>
                    Uniquely repurpose strategic core competencies with
                    progressive content. Assertively transition ethical
                    imperatives and collaborative manufactured products.
                  </p>
                  <a href="#" className="btn btn-outline-brand-01 btn-sm">
                    Write About Us
                  </a>
                </div>
              </div>
              <div className="col-md-6 col-lg-8">
                <div className="owl-carousel owl-theme client-testimonial-2 dot-bottom-center custom-dot">
                  <div className="item">
                    <div className="border single-review-wrap bg-white p-4 m-3">
                      <div className="review-body">
                        <h5>Amazing template</h5>
                        <p>
                          Distinctively foster maintainable metrics whereas
                          multidisciplinary process improvements. Objectively
                          implement strategic niches through.
                        </p>
                      </div>
                      <div className="review-author d-flex align-items-center">
                        <div className="author-avatar">
                          <img
                            src="assets/img/client-2.jpg"
                            width="64"
                            alt="author"
                            className="rounded-circle shadow-sm img-fluid mr-3"
                          />
                          <span>“</span>
                        </div>
                        <div className="review-info">
                          <h6 className="mb-0">Ana Joly</h6>
                          <span>BizBite</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="item">
                    <div className="border single-review-wrap bg-white p-4 m-3">
                      <div className="review-body">
                        <h5>Best template for app</h5>
                        <p>
                          Efficiently innovate customized growth strategies
                          whereas error-free paradigms. Monotonectally enhance
                          stand-alone data with prospective innovation.
                        </p>
                      </div>
                      <div className="review-author d-flex align-items-center">
                        <div className="author-avatar">
                          <img
                            src="assets/img/client-1.jpg"
                            width="64"
                            alt="author"
                            className="rounded-circle shadow-sm img-fluid mr-3"
                          />
                          <span>“</span>
                        </div>
                        <div className="review-info">
                          <h6 className="mb-0">Tony Roy</h6>
                          <span>BizBite</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="item">
                    <div className="border single-review-wrap bg-white p-4 m-3">
                      <div className="review-body">
                        <h5>Efficiently innovate app</h5>
                        <p>
                          Continually redefine sticky channels whereas extensive
                          "outside the box" thinking. Rapidiously supply focused
                          schemas vis-a-vis optimal users.
                        </p>
                      </div>
                      <div className="review-author d-flex align-items-center">
                        <div className="author-avatar">
                          <img
                            src="assets/img/client-3.jpg"
                            width="64"
                            alt="author"
                            className="rounded-circle shadow-sm img-fluid mr-3"
                          />
                          <span>“</span>
                        </div>
                        <div className="review-info">
                          <h6 className="mb-0">Ana Joly</h6>
                          <span>BizBite</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="item">
                    <div className="border single-review-wrap bg-white p-4 m-3">
                      <div className="review-body">
                        <h5>Uniquely mesh flexible</h5>
                        <p>
                          Phosfluorescently optimize intermandated platforms
                          without integrated infrastructures. Proactively
                          redefine granular thinking before.
                        </p>
                      </div>
                      <div className="review-author d-flex align-items-center">
                        <div className="author-avatar">
                          <img
                            src="assets/img/client-4.jpg"
                            width="64"
                            alt="author"
                            className="rounded-circle shadow-sm img-fluid mr-3"
                          />
                          <span>“</span>
                        </div>
                        <div className="review-info">
                          <h6 className="mb-0">Ana Joly</h6>
                          <span>BizBite</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="item">
                    <div className="border single-review-wrap bg-white p-4 m-3">
                      <div className="review-body">
                        <h5>Uniquely mesh flexible</h5>
                        <p>
                          Phosfluorescently optimize intermandated platforms
                          without integrated infrastructures. Proactively
                          redefine granular thinking before.
                        </p>
                      </div>
                      <div className="review-author d-flex align-items-center">
                        <div className="author-avatar">
                          <img
                            src="assets/img/client-1.jpg"
                            width="64"
                            alt="author"
                            className="rounded-circle shadow-sm img-fluid mr-3"
                          />
                          <span>“</span>
                        </div>
                        <div className="review-info">
                          <h6 className="mb-0">Ana Joly</h6>
                          <span>BizBite</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="item">
                    <div className="border single-review-wrap bg-white p-4 m-3">
                      <div className="review-body">
                        <h5>Holisticly reintermediate</h5>
                        <p>
                          Collaboratively reintermediate out-of-the-box
                          e-business via economically sound supply chains.
                          Dynamically target client-based holistic information.
                        </p>
                      </div>
                      <div className="review-author d-flex align-items-center">
                        <div className="author-avatar">
                          <img
                            src="assets/img/client-2.jpg"
                            width="64"
                            alt="author"
                            className="rounded-circle shadow-sm img-fluid mr-3"
                          />
                          <span>“</span>
                        </div>
                        <div className="review-info">
                          <h6 className="mb-0">Ana Joly</h6>
                          <span>BizBite</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/*testimonial and review section end*/}
      </div>
    </div>
  );
};

export default WebsiteBuilder;
